<template>
    <form role="form">
        <div class="container-fluid" style="overflow-y: scroll; height: 520px;">
            <!--___________________________RIEPILOGO___________________________-->
            <div class="row">
                <!--___________________________DATI GENERALI___________________________-->
                <div class="col-md-3">
                    <label class="text-left">{{datiGeneraliLbl}}</label>
                    <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                    <div class="form-group">
                        <div class="col-sm-4">
                            <span class="align-middle label-cust">{{riferimentoLbl}}</span>
                        </div>
                        <div class="col-sm-8">
                            <input readonly v-model="riferimentoValue" type="text" id="riferimentoId" class="form-control form-control-cust"/>
                        </div>
                    </div>
                    <cfg cid="shopCart.vsRif" tag='div'>
                        <div class="form-group">
                            <div class="col-sm-4">
                                <span class="align-middle label-cust">{{vostroRiferimentoLbl}}</span>
                            </div>
                            <div class="col-sm-8">
                                <input readonly v-model="vostroRiferimentoValue" type="text" id="vostroRiferimentoId" class="form-control form-control-cust"/>
                            </div>
                        </div>
                    </cfg>
                    <cfg cid="shopCart.tipoOrdine" tag='div'>
                        <div class="form-group">
                            <div class="col-sm-4">
                                <span class="align-middle label-cust">{{tipoOrdineLbl}}</span>
                            </div>
                            <div class="col-sm-8">
                                <input readonly type="text" v-model="tipoOrdineValue.type" id="tipoOrdineId" class="form-control form-control-cust"/>
                            </div>   
                        </div>
                    </cfg>
                    <cfg cid="shopCart.scontoBase" tag='div'>
                        <div class="form-group" v-if="!$root.token.hidePrices && showScontoBase">
                            <div class="col-sm-4">
                                <span class="align-middle label-cust">{{scontoBaseLbl}}</span>
                            </div>
                            <div class="col-sm-8">
                                <input readonly v-model="scontoBaseValue" type="text" id="scontoBaseId" @change="scontoBaseChangeEvent" class="form-control form-control-cust"/>
                            </div>
                        </div>                            
                    </cfg>
                    <cfg cid="shopCart.note" tag='div'>
                        <div class="form-group">
                            <div class="col-sm-2">
                                <span class="">{{noteLbl}}</span>
                            </div>
                            <div class="col-sm-10">
                                <textarea readonly id="noteId" rows="2" class="form-control" v-model="noteValue" data-role="textarea" style="max-width: 100%; max-height: 138px;"></textarea>
                            </div>
                        </div>
                    </cfg>
                </div>

                <!--___________________________CONSEGNA___________________________-->
                <div class="col-md-4">
                    <label class="text-left">{{datiConsegnaLbl}}</label>
                    <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                    <div class="form-group">
                        <div class="col-md-12">
                            <input readonly type="text" v-model="nominativoConsegna" id="nominativoConsegnaId" class="form-control form-control-cust"/>
                        </div>                        
                    </div>
                    <div class="form-group">
                        <div class="col-md-12">
                            <input readonly v-model="indirizzoConsegna" type="text" id="indirizzoConsegnaId" class="form-control form-control-cust"/>
                        </div>    
                    </div>
                    <div class="form-group">
                        <div class="col-md-12">
                            <input readonly v-model="locCapConsegna"  type="text" id="locCapConsegnaId" class="form-control form-control-cust" />
                        </div>  
                    </div>
                    <div class="form-group">
                        <div class="col-md-12">
                            <input readonly v-model="nazioneConsegna" type="text" id="nazioneConsegnaId" class="form-control form-control-cust"/>
                        </div>
                    </div>
                    <cfg cid="shopCart3.shippingType" tag='div'>
                        <div class="form-group">
                            <div class="col-sm-6">
                                <span class="align-middle label-cust">{{tipoSpedLbl}}</span>
                            </div>
                            <div class="col-sm-6">
                                <input readonly v-model="tipoSped" type="text" id="spedizione" class="form-control form-control-cust"/>
                            </div>
                        </div>
                    </cfg>
                    <cfg cid="shopCart3.portType" tag='div'>
                        <div class="form-group">
                            <div class="col-sm-6">
                                <span class="align-middle label-cust">{{tipoPortLbl}}</span>
                            </div>
                            <div class="col-sm-6">
                                <input readonly v-model="tipoPort" type="text" id="porto" class="form-control form-control-cust"/>
                            </div>
                        </div>
                    </cfg>
                    <cfg v-if="showReqDeliveryDate" cid="shopCart3.deliveryDate" tag='div'>
                        <div class="form-group">
                            <div class="col-sm-6">
                                <span class="align-middle label-cust">{{dataConsegnaLbl}}</span>
                            </div>
                            <div class="col-sm-6">
                                <input readonly v-model="dataConsegna" type="text" id="data" class="form-control form-control-cust"/>
                            </div>
                        </div>
                    </cfg>
                    <cfg v-if="showUnifyDelivery" cid="shopCart3.unifyDelivery" tag='div'>
                        <div class="form-group">
                            <div class="col-sm-6">
                                <span class="align-middle label-cust">{{accorpaSpedLbl}}</span>
                            </div>
                            <div class="col-sm-6">
                                <input readonly v-model="accorpaSped" type="text" id="accorpa" class="form-control form-control-cust"/>
                            </div>
                        </div>
                    </cfg>
                </div>

                <!--___________________________IMPORTO___________________________-->
                <cfg cid="shopCart.importo" tag='div'>
                    <div v-if="!$root.token.hidePrices" class="col-md-2">
                        <label class="text-left">{{importoLbl}}</label>
                        <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                        <div class="form-group">
                            <div class="col-sm-12">
                                <input readonly type="text" v-model="importoValue"  id="importoValueId" class="form-control form-control-cust"/>
                            </div>
                        </div>
                        <div class="form-group">
                            <span class="align-middle">&nbsp;</span>
                        </div>
                    </div>
                </cfg>

                <!--___________________________RICHIEDENTE___________________________-->
                <div v-if="isAlternate" class="col-md-3">
                    <label class="text-left">{{richiedenteLbl}}</label>
                    <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                    <div class="form-group">
                        <div class="col-sm-12">
                            <div class="col-sm" >
                                <input readonly type="text" v-model="nomeRicValue"  id="nomeRicValueId" class="form-control form-control-cust"/>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-12">
                            <div class="col-sm">
                                <input readonly v-model="mailRicValue" type="text" id="indirizzoConsegnaId" class="form-control form-control-cust"/>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-12">
                            <div class="col-sm">
                                <input readonly v-model="faxRicValue" type="text" id="locCapConsegnaId" class="form-control form-control-cust"/>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-12">
                            <div class="col-sm">
                                <input readonly v-model="telRicValue" type="text" id="nazioneConsegnaId" class="form-control form-control-cust"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!--___________________________TABELLA PRODOTTI___________________________-->
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <div style="padding: 5px;">
                            <grid :columns="gridProdAttributesCfg.columns"
                                    :source.sync="arrayToTable" :options="options" :others="others"
                                    :lang="$root.token.idLingua" :name="gridProdAttributesCfg.title">
                            </grid>
                        </div>
                    </div>
                </div>
            </div>          
            <div class="row">
                <div class="col-md">&nbsp;</div>
            </div>

            <!--___________________________PULSANTI___________________________-->      
            <div class="row">
                <div class="col-md-5">
                    <div class="row">
                        <div class="col-sm-3">
                            <button @click.prevent="previousClick" class="btn btn-primary-default" style="width: 100%">{{indietroBtnLbl}}</button>
                        </div>
                        <cfg class="col-sm-3" cid="shopCart.nuovoOrdineBtn" tag='div'>
                            <button @click.prevent="cleanShopCartClick"  class="btn btn-danger" style="width: 100%">{{$Jed.firstUpperTranslate('new order')}}</button>
                        </cfg>
                        <cfg class="col-sm-4" cid="shopCart.printPreviewBtn" tag='div'>
                            <button :disabled="!orderSynced" @click.prevent="$root.printOrder(riferimentoValue)"  class="btn btn-primary-default" style="width: 100%">{{$Jed.firstUpperTranslate('print preview')}}</button>
                        </cfg>
                    </div>
                </div>
                <div class="col-md-1">&nbsp;</div>
                <div class="col-md-3">
                    <button @click.prevent="saveDraft" class="btn btn-warning" style="width: 100%">{{salvaBozzaBtnLbl}}</button>
                </div>
                <div class="col-md-3">
                    <button :disabled="!orderSynced" @click.prevent="sendOrder" class="btn btn-success" style="width: 100%">{{inviaBtnLbl}}</button>
                </div>
            </div>
            <div class="row">
                <div class="col-md">&nbsp;</div>
            </div>
        </div>

        <div v-show="sendingCart" id="sendingCart" style="opacity:1; background: rgba(255, 255, 255, 0.65); z-index: 9999; position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;transition: opacity 0.3s;
            transform: translate3D(0, 0, 0);">
            <div class="sk-cube-grid" style="margin-top: 20%;">
                <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
            </div>
        </div>
    </form>
</template>

<script>

import Grid from '../../dynamic/jqwGridWrapper/jqwGridWrapper.vue'
import FormMixin from '../../dynamic/inputWrapper/formMixin.js'
import DynTableWrapper from "../../dynamic/DynTableWrapper.vue";
import vSelect from "../../dynamic/vueSelectWrapper/components/Select.vue"
import table_resize_mixin from "../../../mixins/table_resize_mixin.js";
import { eventBus } from "../../../eventbus";
import Cfg from "../../dynamic/ConfigurableComponent.vue";

export default {
    mixins: [FormMixin],
    components: {
        Grid,
        DynTableWrapper,
        vSelect,
        Cfg
    },
    props:{
        isAlternate: Boolean
    },
    data: function () {
        var vm = this;
        return {
            datiGeneraliLbl: vm.$Jed.firstUpperTranslate('general data'),
            datiConsegnaLbl: vm.$Jed.firstUpperTranslate('delivery data'),
            importoLbl: vm.$Jed.firstUpperTranslate('amount'),
            richiedenteLbl: vm.$Jed.firstUpperTranslate('requester'),
            riferimentoLbl: vm.$Jed.firstUpperTranslate('reference'),
            vostroRiferimentoLbl: vm.$Jed.firstUpperTranslate('your ref'),
            tipoOrdineLbl: vm.$Jed.firstUpperTranslate('order type'),
            noteLbl: vm.$Jed.firstUpperTranslate('note',2),
            scontoBaseLbl: vm.$Jed.firstUpperTranslate('base discount'),
            indietroBtnLbl: vm.$Jed.firstUpperTranslate('back'),
            salvaBozzaBtnLbl: vm.$Jed.firstUpperTranslate('save order draft'),
            tipoSpedLbl: vm.$Jed.firstUpperTranslate('Tipo Spedizione'),
            tipoPortLbl: vm.$Jed.firstUpperTranslate('port type'),
            dataConsegnaLbl: vm.$Jed.firstUpperTranslate('requested delivery date'),
            accorpaSpedLbl: vm.$Jed.firstUpperTranslate('Accorpa Spedizione'),
            
            riferimentoValue: vm.$root.shopCartData.riferimento,
            vostroRiferimentoValue:  vm.$root.shopCartData.vostroRif,
            
            nominativoConsegna: vm.$root.shopCartData.consegna.nominativo ? vm.$root.shopCartData.consegna.nominativo : (vm.$root.shopCartData.anagraficaCliente.ragioneSociale ? vm.$root.shopCartData.anagraficaCliente.ragioneSociale : ''),
            indirizzoConsegna: vm.$root.shopCartData.altroindirizzoconsegna.indirizzo ? vm.$root.shopCartData.altroindirizzoconsegna.indirizzo : (vm.$root.shopCartData.consegna.indirizzo ? vm.$root.shopCartData.consegna.indirizzo : ''),
            localitaConsegna: vm.$root.shopCartData.altroindirizzoconsegna.localita ? vm.$root.shopCartData.altroindirizzoconsegna.localita : (vm.$root.shopCartData.consegna.localita ? vm.$root.shopCartData.consegna.localita : ''),
            capConsegna: vm.$root.shopCartData.altroindirizzoconsegna.cap ? vm.$root.shopCartData.altroindirizzoconsegna.cap : (vm.$root.shopCartData.consegna.cap ? vm.$root.shopCartData.consegna.cap : ''),
            sigProConsegna: vm.$root.shopCartData.consegna.sigPro ? vm.$root.shopCartData.consegna.sigPro : (vm.$root.shopCartData.consegna.provincia ? vm.$root.shopCartData.consegna.provincia : ''),
            locCapConsegna: '',
            nazioneConsegna: vm.$root.shopCartData.altroindirizzoconsegna.nazione ? vm.$root.shopCartData.altroindirizzoconsegna.nazione : (vm.$root.shopCartData.consegna.nazione ? vm.$root.shopCartData.consegna.nazione : ''),

            tipoSped: vm.$root.shopCartData.spedizione.tipoSpedizioneDes,
            tipoPort: vm.$root.shopCartData.consegna.tipoPortoDes,
            dataConsegna: vm.$root.shopCartData.consegna.consegnaRichiesta,
            accorpaSped: vm.$root.shopCartData.spedizione.accorpaSpedizione,
            
            tipoOrdineValue: vm.$root.shopCartData.tipoOrdine,
            scontoBaseValue: vm.$root.shopCartData.scontoBase,  
            showScontoBase: true,
            riduzioneScontoValue: 0,
            noteValue:  vm.$root.shopCartData.note,        
            
            importoValue: vm.$root.shopCartData.importo,

            nomeRicValue: vm.$root.shopCartData.altrorichiedente.nomecognome ? vm.$root.shopCartData.altrorichiedente.nomecognome : vm.$root.shopCartData.richiedente.nomecognome,
            mailRicValue: vm.$root.shopCartData.altrorichiedente.mail ? vm.$root.shopCartData.altrorichiedente.mail : vm.$root.shopCartData.richiedente.mail,
            faxRicValue: vm.$root.shopCartData.altrorichiedente.fax ? vm.$root.shopCartData.altrorichiedente.fax : vm.$root.shopCartData.richiedente.fax,
            telRicValue: vm.$root.shopCartData.altrorichiedente.telefono ? vm.$root.shopCartData.altrorichiedente.telefono : vm.$root.shopCartData.richiedente.telefono,
            
            tipoOrdineOptionsValue: [{  
                value: 1,
                type: vm.$Jed.firstUpperTranslate('Standard'),
                discount: 0
            }],
            tipoOrdineValue: {  
                value: 1,
                type: vm.$Jed.firstUpperTranslate('Standard')
            },

            APIGridShopCart: null,
            options: {
                columnsresize: true,
                columnsreorder: true,
                columnsmenu: vm.$Components.TabellaProdotti.options.columnsmenu,
                rowsheight: 26,
                theme: "light",
                width: "100%",
                selectionmode: "none",
                pageable: true,
                showfilterrow: false,
                filterable: true,
                sortable: true,
                pageable: false,
                autoheight: false,
                height: 150,
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails:
                        "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
                    rowdetailsheight: 250 /* ! 230 + 20 ! */
                },
                /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
                ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
                initrowdetails: "nested",
                rendered: null,
                ready: function(){
                    $("#TabellaProdotti").jqxGrid('sortby', 'cod', 'asc');
                }
            },
            others:{
                adaptColumns: true
            },
            gridProdAttributesCfg: {
                ID: "gridProdAttributesId",
                title: "TabellaProdotti",
                label_title: "",
                visible: true,
                columns: {
                    configs:{
                        codice: {
                            text: vm.$Jed.firstUpperTranslate('code'),
                            position: 1,
                            visible: true,
                            editable: false,
                            width: "10%",
                            searchable: false,
                            sorting: true,
                            datafield: "cod"
                        },
                        descr: {
                            text: vm.$Jed.firstUpperTranslate('description'),
                            position: 2,
                            visible: true,
                            editable: false,
                            width: vm.$root.token.hidePrices ? "24%" : "25%",
                            searchable: false,
                            sorting: true,
                            datafield: "descr"
                        },
                        sost: {
                            text: vm.$Jed.firstUpperTranslate('substitutes'),
                            position: 3,
                            visible: true,
                            editable: false,
                            width: "10%",
                            searchable: false,
                            sorting: true,
                            datafield: "sost"
                        },
                        unitmis: {
                            text: vm.$Jed.firstUpperTranslate('unit of measure'),
                            position: 4,
                            visible: true,
                            editable: false,
                            width: "12%",
                            searchable: false,
                            sorting: true,
                            datafield: "unitmis"
                        },
                        qty: {
                            text: vm.$Jed.firstUpperTranslate('qty'),
                            position: 5,
                            visible: true,
                            editable: false,
                            width: "7%",
                            searchable: false,
                            sorting: true,
                            datafield: "qty",
                            cellsrenderer: function (data_row, datafield, value) {
                                if(value){
                                    return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: center; "><span style="margin-right: 6px">' + Number(value).toLocaleString() + '</span></div></div>'; //'<i class="icon-modificare"></i> '+
                                }
                            }
                        },
                        originprice: {
                            text: vm.$Jed.firstUpperTranslate('price'),
                            position: 6,
                            visible: true,
                            hidden: vm.$root.token.hidePrices,
                            editable: false,
                            width: "8%",
                            searchable: false,
                            sorting: true,
                            datafield: "originprice",
                            cellsalign: 'right', 
                            tobecellsrenderered: function(datarow, row, columnfield, value, defaulthtml, columnproperties){
                                if(value && value != ""){
                                    var csy = datarow.csy ? datarow.csy : vm.$root.token.valuta
                                    return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: ' + columnproperties.cellsalign + '"><span style="margin-right: 6px">' + Number(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' ' + csy + '</span></div></div>';
                                } else {
                                    return ""
                                }
                            }
                        },
                        uprice: {
                            text: vm.$Jed.firstUpperTranslate('unitary price'),
                            position: 6,
                            visible: true,
                            hidden: vm.$root.token.hidePrices,
                            editable: false,
                            width: "8%",
                            searchable: false,
                            sorting: true,
                            datafield: "uprice",
                            cellsalign: 'right', 
                            tobecellsrenderered: function(datarow, row, columnfield, value, defaulthtml, columnproperties){
                                if(value && value != ""){
                                    var csy = datarow.csy ? datarow.csy : vm.$root.token.valuta
                                    return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: ' + columnproperties.cellsalign + '"><span style="margin-right: 6px">' + Number(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' ' + csy + '</span></div></div>';
                                } else {
                                    return ""
                                }
                            }
                        },                        
                        totprice: {
                            text: vm.$Jed.firstUpperTranslate('Prezzo Totale'),
                            position: 7,
                            visible: true,
                            hidden: vm.$root.token.hidePrices,
                            editable: false,
                            width: "8%",
                            searchable: false,
                            sorting: true,
                            datafield: "totprice",
                            cellsalign: 'right', 
                            tobecellsrenderered: function(datarow, row, columnfield, value, defaulthtml, columnproperties){
                                if(value && value != ""){
                                    var csy = datarow.csy ? datarow.csy : vm.$root.token.valuta
                                    return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: ' + columnproperties.cellsalign + '"><span style="margin-right: 6px">' + Number(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' ' + csy + '</span></div></div>';
                                } else {
                                    return ""
                                }
                            }
                        },
                        scArt:{
                            text: vm.$Jed.firstUpperTranslate('product discount'),
                            position: 11,
                            visible: true,
                            editable: false,
                            width: "9%",
                            searchable: false,
                            sorting: true,
                            datafield: "scArt"
                        },
                        codlinea: {
                            text: vm.$Jed.firstUpperTranslate('line code'),
                            position: 8,
                            visible: true,
                            editable: false,
                            width: "10%",
                            searchable: false,
                            sorting: true,
                            datafield: "codlinea"
                        },
                        codmacch: {
                            text: vm.$Jed.firstUpperTranslate('machine code'),
                            position: 9,
                            visible: true,
                            editable: false,
                            width: "10%",
                            searchable: false,
                            sorting: true,
                            datafield: "codmacch"
                        },
                        desmacch: {
                            text: vm.$Jed.firstUpperTranslate('machine description'),
                            position: 10,
                            visible: true,
                            editable: false,
                            width: "22%",
                            searchable: false,
                            sorting: true,
                            datafield: "desmacch"
                        },
                        noteRig: {
                            text: vm.$Jed.firstUpperTranslate('row notes'),
                            position: 12,
                            visible: true,
                            editable: false,
                            width: "10%",
                            searchable: false,
                            sorting: true,
                            datafield: "noteRiga"
                        },
                        statoDis: {
                            text: vm.$Jed.firstUpperTranslate('availability'),
                            position: 0,
                            visible: true,
                            editable: true,
                            width: "3%",
                            searchable: false,
                            sorting: true,
                            datafield: "statoDisponibilità",
                            iconcolumn: true,
                            customicon: true,
                            setcustomicon: function(data_row) {
                                if(vm.$Behaviors.availabilityStatus.semaphore){
                                    var sem = Object.values(vm.$Behaviors.availabilityStatus.semaphore).find(s => s.value == data_row.statoDis);
                                    if(data_row.statoDis && sem){
                                        return  "<i class='"+vm.$root.icons.circle + " icon-stack-1x' style='color:"+sem.color +";'></i>"; 
                                    }else{
                                        return  "<i class='"+vm.$root.icons.circle + " icon-stack-1x' style='color: grey;'></i>"; 
                                    }
                                }
                            }
                        }
                    }
                }
            },
            arrayToTable: [],
            focus: null,
            riduzioneScontoValue: 0,
            showReqDeliveryDate: true,
            showUnifyDelivery: true,
            orderSynced: this.$root.shopCartData.id>0,
            reg_parameters: null,
            sendingCart: false
        }
    },
    computed: {
        inviaBtnLbl(){
            if(this.$Behaviors.erpgInterface){
                var unavailProd = this.checkAvailAndPrice();
                return unavailProd ? this.$Jed.firstUpperTranslate('request offer') : this.$Jed.firstUpperTranslate('send')
            }else{
                return this.$Jed.firstUpperTranslate('send')
            }
        }
    },
    watch: {
        importoValue: function(){
            this.importoValue = Number(this.importoValue) ? Number(this.importoValue).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : this.importoValue;
        }
    },
    created:  function()  {
        var vm = this;

        if(vm.$root.shopCartData.altroindirizzoconsegna.cap){
            vm.locCapConsegna = vm.$root.shopCartData.altroindirizzoconsegna.cap + " " + 
                                (vm.$root.shopCartData.altroindirizzoconsegna.localita ? vm.$root.shopCartData.altroindirizzoconsegna.localita : '') + 
                                (vm.$root.shopCartData.altroindirizzoconsegna.provincia ? " (" + vm.$root.shopCartData.altroindirizzoconsegna.provincia+")" : '')
        }else{
            if(vm.$root.shopCartData.consegna.cap){
                vm.locCapConsegna += vm.$root.shopCartData.consegna.cap + " "
            }
            if(vm.$root.shopCartData.consegna.localita){
                vm.locCapConsegna += vm.$root.shopCartData.consegna.localita + " "
            }
            if(vm.$root.shopCartData.consegna.sigPro){
                vm.locCapConsegna += " (" + vm.$root.shopCartData.consegna.sigPro +")"
            }else if(vm.$root.shopCartData.consegna.provincia){
                vm.locCapConsegna += " (" + vm.$root.shopCartData.consegna.provincia + ")"
            }
        }

        var idU = vm.$root.token.idUtente;
        var idC = vm.$root.token.idCliente;
        vm.$root.getOrderTypeOptions(idC).then(result=>{
            vm.tipoOrdineOptionsValue = result
            var tipoOrdineItem = vm.tipoOrdineOptionsValue && vm.tipoOrdineOptionsValue.length>0 ? vm.tipoOrdineOptionsValue.find(o => o.type == vm.$root.shopCartData.tipoOrdine ) : 'Standard';  
            vm.tipoOrdineValue = tipoOrdineItem != null ? tipoOrdineItem : vm.tipoOrdineOptionsValue[0];                 
            if((vm.tipoOrdineValue.type == 'Urgente' && vm.$Configs.discountReductPerc)){ //se è stabilita una percentuale di riduzione sconto (TM Racing)
                vm.showScontoBase = false;
                //devo ricalcolare entrambe le colonne che mostrano lo sconto articolo/cliente
                //applicando la riduzione di sconto per l'ordine urgente: se è generica sta in discountReductPerc, se è specifica per cliente è nel value del typeOrder Urgente
                vm.riduzioneScontoValue = vm.tipoOrdineValue.value ? vm.tipoOrdineValue.value : vm.$Configs.discountReductPerc
            }else{
                vm.riduzioneScontoValue = 0
                vm.showScontoBase = vm.$Configs.discountReductPerc ? false : true;
                vm.scontoBaseValue = vm.tipoOrdineValue.value ? vm.tipoOrdineValue.value === 100.0 ? 0 : vm.tipoOrdineValue.value : 0;
            }
            vm.refreshGrid();  
        })
        eventBus.$on("gotChanges",()=>{
            var reg_orders = vm.$root.dbRegistry.getCollection('orders'),
                order = reg_orders.find({'$loki': vm.$root.shopCartData.$loki}); //uso $loki perchè questo serve per aggiornare le schermate quando ho inserito un prodotto in carrello e ancora ci sono gli id provvisori (negativi) per ordine e righeordine
            if(order && order[0]){
                //imposto il nuovo id per la struttura che rappresenta il carrello (cioè ShopCartData) così posso usare questa proprietà per recuperare il record dall'idb quando serve
                vm.$root.shopCartData.id = order[0].id;

                //aggiorno i campi della videata che potrebbero avere subito delle modifiche con la sync bi-dir
                vm.riferimentoValue = order[0].id;
                
                //aggiorno interfaccia alla risposta della sync dopo GetOrderState: mi risponde con lo stato dell'ordine
                vm.$root.shopCartData.statoOrdine = order[0].osi;
            }

            //sblocca pulsante anteprima di stampa e pulsante invia:
            vm.orderSynced = true;
        })

        this.dataConsegna = this.dataConsegna ? new Date(this.dataConsegna).toLocaleDateString() : ''
        if(this.$Behaviors.enableDeliveryDateOnlyForEXWPort){ //abilita “data consegna richiesta” quando il porto è franco fabbrica
            if(this.$root.shopCartData.consegna.tipoPortoFre=='Fabbrica'){
                this.showReqDeliveryDate = true
            }else{
                this.showReqDeliveryDate = false
            }
        }else{
            this.showReqDeliveryDate = true
        }
        //se nello step 2 l'area del tipo spedizione è nascosta, nascondo il campo "accorpa spedizione"
        this.showUnifyDelivery = !this.$Components["shopCart2.shippingTypeArea"].hidden

        this.loadCollections();
    }, 
    mounted: function() {
        var vm = this;
        var tipoOrdineItem = this.tipoOrdineOptionsValue && this.tipoOrdineOptionsValue.length>0 ? this.tipoOrdineOptionsValue.find(o => o.type == this.$root.shopCartData.tipoOrdine) : 'Standard' 
        this.tipoOrdineValue = tipoOrdineItem != null ? tipoOrdineItem : this.tipoOrdineOptionsValue[0];

        if(this.$Behaviors.erpgInterface){//aggiorna disponibilità quando il carrello viene aperto
            vm.orderSynced = false;
            this.$root.updateAvailability();
        }
    },
    methods: {
        async loadCollections(){
            var vm = this;
            try {                
                vm.reg_parameters = await vm.$root.fetchRegistryData("parameters", "GetParameters", "collection");
            }catch(err){
                console.log(err)
            }
        },
        updateData( ) {
            console.log('ShopCart3 - updateData')
            this.riferimentoValue = this.$root.getTempReferenceId();
            this.vostroRiferimentoValue = this.$root.shopCartData.vostroRif;

            var tipoOrdineItem = this.tipoOrdineOptionsValue.find(o => o.type == this.$root.shopCartData.tipoOrdine );
            this.tipoOrdineValue = tipoOrdineItem != null ? tipoOrdineItem : this.tipoOrdineOptionsValue[0];                    
            this.scontoBaseValue = this.$root.shopCartData.scontoBase;
            this.importoValue = this.$root.shopCartData.importo;
            this.noteValue = this.$root.shopCartData.note;

            this.nomeRicValue = this.$root.shopCartData.richiedente.nomecognome
            this.mailRicValue = this.$root.shopCartData.richiedente.mail
            this.faxRicValue = this.$root.shopCartData.richiedente.fax
            this.telRicValue = this.$root.shopCartData.richiedente.telefono

            this.nominativoConsegna = this.$root.shopCartData.consegna.nominativo ? this.$root.shopCartData.consegna.nominativo : this.$root.shopCartData.anagraficaCliente.ragioneSociale;
            this.indirizzoConsegna = this.$root.shopCartData.consegna.indirizzo;
            this.localitaConsegna = this.$root.shopCartData.consegna.localita 
            this.capConsegna = this.$root.shopCartData.consegna.cap
            this.sigProConsegna = this.$root.shopCartData.consegna.sigPro ? this.$root.shopCartData.consegna.sigPro : this.$root.shopCartData.consegna.provincia
            this.locCapConsegna = this.capConsegna + " " + this.localitaConsegna + " (" + this.sigProConsegna+")"
            this.nazioneConsegna = this.$root.shopCartData.consegna.nazione 

            this.refreshGrid();
        },
        refreshGrid() {
            this.arrayToTable = [];
            var products = this.$root.shopCartData.prodotti,
                elem, colSc;
            for(var idx = 0; idx <products.length; idx++){       
                elem = products[idx];   
                if(this.riduzioneScontoValue || this.riduzioneScontoValue == 0){ //devo ricalcolare gli sconti sia quando la percentuale di riduzione ha un valore > 0 sia quando è 0 (ordine std) per tornare agli sconti iniziali
                    var scCliView = elem.scontoCliente - (elem.scontoCliente / 100 * this.riduzioneScontoValue),
                        scArtView = elem.scontoArticolo - (elem.scontoArticolo / 100 * this.riduzioneScontoValue)
                }  
                colSc = scCliView && scArtView ? scCliView + ' + ' + scArtView : scArtView ? scArtView : scCliView ? scCliView : ''
                this.arrayToTable.push({
                    refObj: elem,
                    id: elem.id != 0 ? elem.id : '', 
                    unitmis: this.$Jed.translate(elem.unitaMisura),
                    qty: elem.quantita,
                    cod: elem.codiceProd, 
                    sost: elem.codSost,
                    uprice: elem.prezzoUnitario,
                    totprice: elem.prezzoTotale.toFixed(2),
                    originprice: elem.prezzoOriginario,
                    descr: elem.descrizione,
                    codlinea: elem.codlinea,
                    codmacch: elem.codmacch,
                    desmacch: elem.desmacch,
                    scArt: colSc,
                    noteRiga: elem.noteRiga ? elem.noteRiga : '',
                    statoDis: elem.statoDisponibilità
                }) 
            }                  
        },
        previousClick () {
            if(this.$Behaviors.hideDeliveryCartStep){
                this.$emit('changeComponentEvent', 1, this.getData());
            }else{
                this.$emit('changeComponentEvent', 2, this.getData());
            }
        },
        saveDraft () {    
            this.$emit('onSaveDraftEvent', this.getData());
        },
        checkAvailAndPrice(){
            //se lo stato disponibilità del prodotto in ordine è diverso da "Buona"
            //oppure
            //il prezzo unitario è vuoto o nullo
            //console.log(this.$root.shopCartData.prodotti)
            return this.$root.shopCartData.prodotti.find((p) => p.statoDisponibilità != this.$Behaviors.availabilityStatus.semaphore['good'].value) || 
                    this.$root.shopCartData.prodotti.find((p) => p.prezzoUnitario == '' || p.prezzoUnitario == null)
        },
        sendOrder () {
            //mostro il waiter invio ordine così l'utente ha feedback
            this.sendingCart = true;
            $("#sendingCart").css("display","block");

            if(this.$Behaviors.erpgInterface){
                var mode, 
                    vm = this,
                    check = this.checkAvailAndPrice();
                if(check){
                    //c'è almeno un prodotto non disponibile 
                    //o
                    //c'è almeno un prodotto con il prezzo non definito
                    console.log('in attesa di verifica')
                    
                    //imposto stato ordine con id dello stato "da verificare"
                    var idStato = vm.reg_parameters.find({id: 'Id Stato Ordine Da Verificare'})[0].val
                    //console.log(vm.reg_parameters.find({id: 'Id Stato Ordine Da Verificare'})[0])
                        
                    vm.$root.shopCartData.statoOrdine = Number(idStato)
                    //console.log(vm.$root.shopCartData.statoOrdine, typeof vm.$root.shopCartData.statoOrdine)

                    var orderStatusStr = '', 
                        orderStatus = vm.$root.dbRegistry.getCollection('orderStatuses').findOne({ 'id': Number(idStato) });
                    if(orderStatus) {
                        orderStatusStr  = orderStatus.des[vm.$root.token.siglaLingua] ? orderStatus.des[vm.$root.token.siglaLingua] : orderStatus.des[vm.$root.token.defaultLang];
                    }

                    var e = {
                        icon: "info",
                        title: this.$Jed.firstUpperTranslate('order state'),
                        message: this.$Jed.firstUpperTranslate(orderStatusStr),
                        ok: function(){
                            this.close();
                        },
                        YtxtBtn: this.$Jed.firstUpperTranslate('Ok')
                    }

                    this.sendingCart = false;
                    $("#sendingCart").css("display","none");

                    eventBus.$emit("confirm", e)

                    //salvo l'ordine su registry e sync
                    this.$emit('onSaveOrderEvent', this.getData()); 
                    
                }else{
                    console.log('invia ordine')
                    //Chiama GetOrderState 
                    this.$root
                        .microservice({
                        role: "erpg",
                        cmd: "GetOrderState",
                        params: {
                            orderId: vm.$root.shopCartData.id,
                            mode: 0
                        }
                    }).then((response) => {
                        var res = response.body,
                            message,
                            pickup = null,
                            mail = null,
                            time = null;

                        this.sendingCart = false;
                        $("#sendingCart").css("display","none");

                        try {
                            if(res.stato){
                                message = vm.reg_parameters.find({val: ''+res.stato+''})[0].id
                            }else if(res.err){
                                message = 'order not confirmed'
                            }
                            if(!res.mailInviata){
                                mail = 'mail not sent'
                            }
                            if(res.ritiroInGiornataDaOra){
                                time = vm.reg_parameters.find({id: 'Ora Ordine Utile Per Ritiro In Giornata'})[0].val
                                pickup = 'day pick up %1$s'
                            }

                            var e = {
                                icon: "info",
                                title: this.$Jed.firstUpperTranslate('order state'),
                                message: this.$Jed.firstUpperTranslate(message) + (pickup ? ' \n '+this.$Jed.firstUpperTranslate(pickup, null, {key: time}) : '') + (mail ? ' '+this.$Jed.firstUpperTranslate(mail) : ''),
                                ok: function(){
                                    this.close();
                                },
                                YtxtBtn: this.$Jed.firstUpperTranslate('Ok')
                            }
                            eventBus.$emit("confirm", e)

                        } catch (err) {
                            console.log(err)
                            var e = {
                                icon: "error",
                                title: this.$Jed.firstUpperTranslate('error'),
                                message: err,
                                ok: function(){
                                    this.close();
                                },
                                YtxtBtn: this.$Jed.firstUpperTranslate('Ok')
                            }
                            eventBus.$emit("alert", e)
                        }

                        //dopo aver chiamato il cmd che aggiorna lo stato ordine, salvo l'ordine su registry e sync
                        this.$emit('onSaveOrderEvent', this.getData());                   
                        
                    }, (error) => {
                
                        //vedi gestione errore in main.js > microservice

                    })
                    .catch(err => {
                        console.log(err);
                        var msg = err && err.body && err.body.error ? err.body.error : err
                        eventBus.$emit('alert', {
                            message: "Application caught an error <br> <h5>Details: " + "erpg.GetOrderState - " + msg +'</h5>',
                            type: "error",
                            action: ''
                        })
                    })
                }
            }else{
                this.$emit('onSaveOrderEvent', this.getData());  
            }
        },
        cleanShopCartClick () {
            this.$emit('onCleanShopCartEvent','')  ;      
        },
        changeStep: function(val) { 
            if( val != 3)           
                this.$emit('changeComponentEvent',val, this.getData())  ;  
        },
        scontoBaseChangeEvent: function(ev) {
            this.$root.shopCartData.scontoBase = this.scontoBaseValue;
            this.refreshGrid();
        },
        getData() {
            this.$root.shopCartData.riferimento = this.riferimentoValue,
            this.$root.shopCartData.vostroRif = this.vostroRiferimentoValue;  
            this.$root.shopCartData.scontoBase = this.scontoBaseValue ? this.scontoBaseValue : 0;
            this.$root.shopCartData.importo =  this.importoValue;
            this.$root.shopCartData.tipoOrdine = this.tipoOrdineValue ? this.tipoOrdineValue.type : 'Standard';
            this.$root.shopCartData.note = this.noteValue;

            return this.$root.shopCartData;
        }
    }
}


</script>

<style>
.form-control-cust  {
    height: 28px;
}

.label-cust {
    white-space: nowrap;
}

.v-select input[type=search], .v-select input[type=search]:focus {
    flex-basis: 20px;
    flex-grow: 1;
    height: 28px;
    padding: 0 20px 0 10px;
    width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/ShopCart3.vue?21201ef0